import { render, staticRenderFns } from "./m-documents-sign-status.vue?vue&type=template&id=99c4fd2e&scoped=true&lang=pug"
import script from "./m-documents-sign-status.vue?vue&type=script&lang=js"
export * from "./m-documents-sign-status.vue?vue&type=script&lang=js"
import style0 from "./m-documents-sign-status.vue?vue&type=style&index=0&id=99c4fd2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c4fd2e",
  null
  
)

export default component.exports